module.exports = __webpack_public_path__ + "img/layers-icon-mobile.e348de5a.svg";